import { TConvertor, TCreateConverter, TFetchConverter } from "data/types/Converter.types";
import { TOptionTypeUi } from "data/types/GeneralTypes";
import { ELandlordStatusDB, ELandlordStatusUI, TLandlordGetDB, TLandlordGetUI, TPMEmailsExportUI, TPMEmailsExportDB } from "data/types/Landlord.types";
import { filtersConverter } from './General.converters';

export const analyticsLandlordsQueryConverter: TCreateConverter<
  TOptionTypeUi[],
  { statuses: ELandlordStatusDB[] }
> = {
  toDb: (data) => {
    return {
      statuses: data.map((i) => i.value),
    };
  },
};

export const landlordConverter: TFetchConverter<TLandlordGetUI, TLandlordGetDB> = {
  fromDb: (data) => {
    return {
      id: data.id,
      name: data.businessName,
      username: data.landlordUsername,
      status: landlordStatusConverter.fromDb(data.status),
      propertyManagementId: data.propertyManagementId,
      resourceId: data.landlordId,
    };
  },
};

export const landlordStatusConverter: TConvertor<ELandlordStatusUI, ELandlordStatusDB> = {
  fromDb: (data) => {
    const dataMapper: { [key in ELandlordStatusDB]: ELandlordStatusUI } = {
      [ELandlordStatusDB.ACTIVE]: ELandlordStatusUI.ACTIVE,
      [ELandlordStatusDB.TEST]: ELandlordStatusUI.TEST,
      [ELandlordStatusDB.PROSPECT]: ELandlordStatusUI.PROSPECT,
      [ELandlordStatusDB.NON_LANDLORD]: ELandlordStatusUI.NON_LANDLORD,
      [ELandlordStatusDB.INACTIVE]: ELandlordStatusUI.INACTIVE,
    };
    return dataMapper[data];
  },
  toDb: (data) => {
    const dataMapper: { [key in ELandlordStatusUI]: ELandlordStatusDB } = {
      [ELandlordStatusUI.ACTIVE]: ELandlordStatusDB.ACTIVE,
      [ELandlordStatusUI.TEST]: ELandlordStatusDB.TEST,
      [ELandlordStatusUI.INACTIVE]: ELandlordStatusDB.INACTIVE,
      [ELandlordStatusUI.NON_LANDLORD]: ELandlordStatusDB.NON_LANDLORD,
      [ELandlordStatusUI.PROSPECT]: ELandlordStatusDB.PROSPECT,
    };

    return dataMapper[data];
  },
};

export const propertyManagementEmailsExportConverter: TCreateConverter<TPMEmailsExportUI, TPMEmailsExportDB> = {
  toDb: (data) => {
    if (data.filters) {
      return filtersConverter.toDb(data.filters);
    }
    return {
      propertyManagementIds: data.propertyManagementIds || [],
    };
  },
};